{
  const initFaq = () => {
    const faqSections = document.querySelectorAll('.faq__questions-wrapper');
    
    faqSections.forEach(section => {
      const questions = section.querySelectorAll('.faq__question-title-wrapper');
      
      questions.forEach(question => {
        question.addEventListener('click', (e) => {
          const currentQuestion = e.currentTarget.parentElement;
          const isExpanded = currentQuestion.getAttribute('aria-expanded') === 'true';
          
          // Close all questions in this section first
          section.querySelectorAll('.faq__question').forEach(item => {
            item.setAttribute('aria-expanded', 'false');
          });
          
          // Toggle the current question if it wasn't already expanded
          if (!isExpanded) {
            currentQuestion.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  };

  // Initialize when DOM is fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaq);
  } else {
    initFaq();
  }
}